import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";
import {DirtyWildGameMode} from "./DirtyWildsRespinZeroBetController";
import {DirtyWildsRFSyncEvent} from "./DirtyWildsRFSyncController";

export class DirtyWildsTeaseEvent {
    public static readonly TEASE_INITIATED:string = "dirtyWildsTeaseEvent_teaseInitiated";
}

export class DirtyWildsRandomTeaseController extends BeforeSpinStopPresentationController {
    constructor(index:number, name:string) {
        super(index, name);
    }

    protected getSpinStopDelay(data:ParsedGameData):number {
        return this._timeline.totalDuration();
    }

    protected parseFeatureTriggered(data:DirtyWildsParsedGameData):boolean {
        let canTriggerTease:boolean = false;
        if(!(data.isRandomFeatureTriggered || data.isRandomSyncFeatureTriggered || data.mode === DirtyWildGameMode.STICKY_RESPIN || data.nextMode === DirtyWildGameMode.STICKY_RESPIN)) {
            canTriggerTease = (data.betWins != null && data.betWins.length > 0) ? this.determineTeaseProbability(3, 2) : this.determineTeaseProbability(20, 8);
        }
        if(!(data.isRandomFeatureTriggered || data.isRandomSyncFeatureTriggered || canTriggerTease)) {
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
        }
        return canTriggerTease;
    }

    private determineTeaseProbability(limit:number, fav:number):boolean {
        return (Math.floor(Math.random() * (limit - 0 + 1)) + 0) === fav;
    }

    protected startPresentation(timeLine:TimelineLite):void {
        const tl:TimelineLite = new TimelineLite();
        const spineTl:TimelineLite = DirtyWildGameModuleConfig.environment.startMysteryPresentation("TeaseStart", 0, 340, 370)!;
        EventHandler.dispatchEvent(new GameEvent(DirtyWildsTeaseEvent.TEASE_INITIATED));
        tl.add(DirtyWildGameModuleConfig.effectManager.getTeaseIntense(3), 0);
        tl.add([spineTl, () => SlotGame.sound.playEffect(DirtyWildsSoundConfig.RADNOM_TEASE)], 0);
        tl.add(DirtyWildGameModuleConfig.environment.startMysteryPresentation("Tease", 0, 340, 370), spineTl.totalDuration());
        tl.add([() => EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED)),
            DirtyWildGameModuleConfig.effectManager.getChangeBackgroundAnimation(DirtyWildGameMode.NORMAL, 1)], spineTl.totalDuration());
        tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(DirtyWildsRFSyncEvent.SET_EVENT_VARIABLE, true));
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOP));
        }, spineTl.totalDuration() + 0.4);
    }

    protected stopPresentation(isAborted:boolean):void {
    }
}